// cr_thuoc, cr_vtyt, cr_hc
const API_URL = "https://api.goodapp.vn/api";
const PUBLIC_URL = "https://api.goodapp.vn";
const API_URL_LOCAL = "http://localhost:8081";
// const ID_APP = "66432d1af06bef4e9985aa6a"; // thien thuy
// const ID_APP = "60939744ac969b4078488026"; // dev
// const ID_APP = "66f002780432a228d2b5fde5"; // cr
const ID_APP = "674458167b38488ffa4846a3"; // lac chuong
const PUBLIC_TOKEN = "flex.public.token";

const PTTT_NHAXE: { value: string; label: string }[] = [
  {
    value: "1",
    label: "Nhà xe thu",
  },
  {
    value: "2",
    label: "Tiền mặt",
  },
  {
    value: "3",
    label: "Thanh toán Online",
  },
];

export { API_URL, PUBLIC_URL, ID_APP, PUBLIC_TOKEN, PTTT_NHAXE, API_URL_LOCAL };
